import * as React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import BookSubscription from './book-subscription';
import BookSubscriptionDetail from './book-subscription-detail';
import BookSubscriptionUpdate from './book-subscription-update';
import BookSubscriptionDeleteDialog from './book-subscription-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={BookSubscriptionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={BookSubscriptionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={BookSubscriptionDetail} />
      <ErrorBoundaryRoute path={match.url} component={BookSubscription} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:id/delete`} component={BookSubscriptionDeleteDialog} />
  </>
);

export default Routes;
